module.exports = __webpack_public_path__ + "img/about-banner.c43b4c5f.webp";